import React, { useEffect, useState } from "react";
import { Button, Container, Table } from "react-bootstrap";
import AddUser from "./AddUser";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router";
import { formatDateFromAPI } from "../helpers/functions";
import { useSelector } from "react-redux";
import { selectUser } from "../store/userSlice";

export default function Users() {
  const user = useSelector(selectUser);
  const [users, setUsers] = useState([]);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [search, setSearch] = useState("");
  const [total, setTotal] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();

  const getUsers = async () => {
    let headersList = {
      Accept: "*/*",
    };

    let response = await fetch(
      `/auth/users?limit=${limit}&offset=${offset}&search=${search}`,
      {
        method: "GET",
        headers: headersList,
      }
    );

    let data = await response.json();
    if (response.ok) {
      setUsers(data.data);
      setTotal(data.total);
    } else {
      toast.error(data.error);
      if (response.status === 401) {
        if (user) {
          toast.error("Your session has expired. You need to login again.");
        }
        navigate("/login", { state: { from: location } });
      }
    }
  };

  const changeStatus = async (email, status, inAlerts) => {
    let headersList = {
      Accept: "*/*",
      "Content-Type": "application/json",
    };

    let bodyContent = JSON.stringify({
      Email: email,
      Status: status,
      InAlerts: inAlerts,
    });

    let response = await fetch("/auth/users", {
      method: "PATCH",
      body: bodyContent,
      headers: headersList,
    });

    let data = await response.json();
    if (response.ok) {
      getUsers();
      toast.success(data.message);
    } else {
      toast.error(data.error);
      if (response.status === 401) {
        if (user) {
          toast.error("Your session has expired. You need to login again.");
        }
        navigate("/login", { state: { from: location } });
      }
    }
  };

  useEffect(() => {
    getUsers();
  }, [offset, limit]);

  return (
    <>
      <Container fluid>
        <div className="d-flex justify-content-between my-3">
          <h3>Users</h3>
          <AddUser onAdd={getUsers} />
        </div>
        <Table bordered hover>
          <thead>
            <tr>
              <th>Email</th>
              <th>Created At</th>
              <th>Last Login Time</th>
              <th>Status</th>
              <th>Receive All Alerts</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr>
                <td>{user.Email}</td>
                <td>{formatDateFromAPI(user.CreatedAt)}</td>
                <td>
                  {user.LastLoginAt.Valid
                    ? formatDateFromAPI(user.LastLoginAt.Time)
                    : "N/A"}
                </td>
                <td>
                  <Button
                    variant="secondary"
                    className="badge opacity-75"
                    onClick={() =>
                      changeStatus(
                        user.Email,
                        user.Status === "active" ? "locked" : "active",
                        user.InAlerts
                      )
                    }
                  >
                    {user.Status}
                  </Button>
                </td>
                <td>
                  <Button
                    variant="secondary"
                    className="badge opacity-75"
                    onClick={() =>
                      changeStatus(user.Email, user.Status, !user.InAlerts)
                    }
                  >
                    {user.InAlerts ? "Yes" : "No"}
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <div className="d-flex justify-content-between  align-items-center mt-5 gap-3 ">
          <div>
            <span >{total} users found </span>
          </div>
          <div>
            <Button
              disabled={offset === 0}
              variant="secondary"
              className="btn-sm me-4"
              onClick={() => {
                setOffset(offset - limit);
              }}
            >
              Previous
            </Button>
            <span className="fw-bold"> Page {offset / limit + 1} </span>
            <Button
              disabled={offset + limit > total}
              variant="secondary"
              className="btn-sm ms-4"
              onClick={() => {
                setOffset(offset + limit);
              }}
            >
              Next
            </Button>
          </div>
          <div>
            Show
            <select
              className="btn"
              value={limit}
              onChange={(e) => {
                setLimit(e.target.value);
                setOffset(0);
              }}
            >
              <option value={2}>2</option>
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={100}>100</option>
            </select>
            users per page.
          </div>
        </div>
      </Container>
    </>
  );
}
